import request from '@/utils/request'

// 获取轮播图列表
export function getBannerList(query) {
    return request({
        url: "/web/getBannerList",
        method: "get",
        params: query
    })
}

//获取企业介绍
export function getDeptIntroduction() {
    return request({
        url: '/web/getCompanyIntro',
        method: 'get'
    })
}

//关于乾景
export function getAboutQingjing() {
    return request({
        url: '/web/aboutQingJing',
        method: 'get'
    })
}

//可持续发展
export function getSustainableDevelopment() {
    return request({
        url: '/web/sustainDev',
        method: 'get'
    })
}

//新闻中心列表
export function getNewsList(query) {
    return request({
        url: '/web/getNewsList',
        method: 'get',
        params: query
    })
}

//新闻轮播列表
export function getNewsBannerList() {
    return request({
        url: '/web/getNewsBannerList',
        method: 'get',
    })
}

//新闻详情
export function getNewsDetail(id) {
    return request({
        url: '/web/getNewsDetail/' + id,
        method: 'get',
        params: {
            id
        }
    })
}

//联系我们信息
export function getContactInfo() {
    return request({
        url: '/web/getContactUs',
        method: 'get',
    })
}

//联系我们-发送邮件
export function sendEmail(data) {
    return request({
        url: '/web/sendContactInfo',
        method: 'post',
        data
    })
}

//产品-潜油螺杆泵
export function getPumpList() {
    return request({
        url: '/web/product/artificialLift',
        method: 'get',
    })
}

//产品-辅件
export function getAuxiliaryList() {
    return request({
        url: '/web/getAccessoriesInfo',
        method: 'get',
    })
}

//产品-能源方案
export function getEnergyList() {
    return request({
        url: '/web/product/energySolutions',
        method: 'get',
    })
}

//服务-应用方案
export function getApplicationList() {
    return request({
        url: '/web/getApplicationSolutions',
        method: 'get',
    })
}

//服务-服务方案
export function getServiceList() {
    return request({
        url: '/web/getServiceInfo',
        method: 'get',
    })
}
//切换语言
export function changeLanguage(lang) {
    return request({
        url: '/changeLanguages',
        method: 'get',
        params: {
            lang
        }
    })
}
//资料下载
export function downloadFile(query) {
    return request({
        url: '/web/downloadFile',
        method: 'post',
        params: query
    })
}
